/** https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/#recommendations **/

// forEach method, could be shipped as part of an Object Literal/Module
export default function forEach(array, callback, scope) {
    for (var i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]); // passes back stuff we need
    }
};